export const CustomUrlScheme = {
  prod: 'reality-viewer://',
  dev: 'reality-viewer-dev://',
} as const

export default {
  mediaServerUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? 'https://media.reality.app'
      : 'https://media.lab.reality.app',
  userServerUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? 'https://user.reality.app'
      : 'https://user.lab.reality.app',
  appGatewayServerUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? 'https://appgateway.reality.app'
      : 'https://appgateway.lab.reality.app',
  customUrlScheme:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? CustomUrlScheme.prod
      : CustomUrlScheme.dev,
  transpileDependencies: ['vuex-module-decorators'],
  payoneerLoginPageUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? 'https://login.payoneer.com'
      : 'https://login.sandbox.payoneer.com',
  appImageBaseUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
    ? 'https://reality-public.akamaized.net/app_image'
    : 'https://storage.googleapis.com/vlive-lab-public-origin/app_image',
  commentServerUrl:
    process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
      ? 'wss://comment.reality.app'
      : 'wss://comment.lab.reality.app',
}
